// extracted by mini-css-extract-plugin
module.exports = {"row":"AdminStudentEntry_row__cCIK9","form":"AdminStudentEntry_form__2Us7t","addressBox":"AdminStudentEntry_addressBox__EwK8w"};